<p-confirmDialog
  class="confirm-dialog"
  [closable]="false"
  [visible]="true"
  [header]="'contactUsForm.terminationConfirmation.title' | translate">
  <ng-template pTemplate="message">
    <div class="text-left">
      <!-- Common field: Contract / Quotation Reference (if available) -->
      <ng-container *ngIf="confirmationSummary.contractReference">
        <div class="mb-2">
          <p class="text-dark">
            {{ "contactUsForm.quoteOrPolicy.label" | translate }}
          </p>
          <p class="text-black">{{ confirmationSummary.contractReference }}</p>
        </div>
      </ng-container>

      <!-- Always show the request nature -->
      <div class="mb-2">
        <p class="text-dark">
          {{ "contactUsForm.requestNature.label" | translate }}
        </p>
        <p class="text-black">{{ confirmationSummary.requestNature }}</p>
      </div>

      <!-- Termination specific fields -->
      <ng-container *ngIf="confirmationSummary.terminationReason">
        <div class="mb-2">
          <p class="text-dark">
            {{ "contactUsForm.terminationReason.label" | translate }}
          </p>
          <p class="text-black">{{ confirmationSummary.terminationReason }}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="confirmationSummary.terminationDate">
        <div class="mb-2">
          <p class="text-dark">
            {{ "contactUsForm.terminationDate.label" | translate }}
          </p>
          <p class="text-black">
            {{ confirmationSummary.terminationDate | date: "dd/MM/yyyy" }}
          </p>
        </div>
      </ng-container>

      <!-- Other fields, e.g. attestation type if needed -->
      <ng-container *ngIf="confirmationSummary.attestationType">
        <div class="mb-2">
          <p class="text-dark">
            {{ "contactUsForm.attestationType.label" | translate }}
          </p>
          <p class="text-black">{{ confirmationSummary.attestationType }}</p>
        </div>
      </ng-container>

      <!-- Comments section (always present) -->
      <div
        class="mb-2"
        *ngIf="confirmationSummary.comments">
        <p class="text-dark">
          {{ "contactUsForm.comment.label" | translate }}
        </p>
        <p class="text-black">{{ confirmationSummary.comments }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-center gap-2">
      <button
        pButton
        [label]="'contactUsForm.terminationConfirmation.cancel' | translate"
        (click)="closePopup()"
        class="bg-white border border-primary text-primary w-full font-wigrum-light h-12"></button>

      <button
        pButton
        [label]="'contactUsForm.terminationConfirmation.validate' | translate"
        (click)="confirmRequest()"
        class="bg-primary text-white w-full h-12"></button>
    </div>
  </ng-template>
</p-confirmDialog>
